<template>
  <div class="seek_detail_page">
    <div class="top-container flex_between">
      <div class="flex_center" style="cursor: pointer" @click="back">
        <i class="el-icon-arrow-left" />
        <div class="split"></div>
        {{ $t("part.viewDetail") }}
      </div>
      <div>
        <el-button class="primary-btn" size="small" type="primary" @click="back">{{
          $t("operate.backList")
        }}</el-button>
      </div>
    </div>
    <div class="status-container">
      <div>{{ $t("climant.climantNumber") }}：{{ claimant.claimStatementId }}</div>
      <div class="status">
        {{ $t("climant.status") }}：
        <span v-if="claimant.status == 0">
          <!-- 待提交 -->
          {{ $t("climant.noSubmit") }}
        </span>
        <span
          v-else-if="
            claimant.status == 1 ||
            claimant.status == 3 ||
            claimant.status == 4 ||
            claimant.status == 15 ||
            claimant.status == 16 ||
            claimant.status == 17 ||
            claimant.status == 18 ||
            claimant.status == 21
          "
        >
          <!-- 待审核 -->
          {{ $t("cart.audit") }}
        </span>
        <span v-else-if="claimant.status == 19">
          <!-- 已通过：待确认（责任主体） -->
          {{ $t("home.passed") }}
        </span>
        <span v-else-if="claimant.status == 2">
          <!-- 驳回（预审） -->
          {{ $t("climant.rejected") }}
        </span>
        <span v-else-if="claimant.status == 5">
          <!-- 已拒赔 -->
          {{ $t("climant.claimsRejected") }}
        </span>
        <span v-else-if="claimant.status == 11">
          <!-- 待结算 -->
          {{ $t("climant.djs") }}
        </span>
        <span v-else-if="claimant.status == 12">
          <!-- 已结算 -->
          {{ $t("climant.settleAccounts") }}
        </span>
        <span v-else-if="claimant.status == 13">
          <!-- 已取消 -->
          {{ $t("home.canceled") }}
        </span>
        <span v-else-if="claimant.status == 14">
          <!-- 已撤回 -->
          {{ $t("climant.ych") }}
        </span>
      </div>
      <el-button
        v-if="pageIndex == 'detail'"
        class="btn"
        style="color: #bd3124"
        type="text"
        @click="handleViewRecord('record')"
        >{{ $t("climant.viewRecord") }}</el-button
      >
    </div>

    <div v-if="pageIndex == 'detail'" class="form_info">
      <el-form :inline="true" :model="claimant">
        <!-- 车辆基本信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img class="title-icon" src="@/assets/img/title-icon.svg" alt="dark" />
            {{ $t("seek.basic") }}
          </div>
        </div>
        <div class="form-container">
          <!-- 索赔节点 -->
          <el-form-item :label="$t('claimantKd.spjd')" prop="claimNode">
            <el-select disabled v-model="claimant.claimNode" placeholder=" " filterable clearable>
              <el-option :label="$t('claimantKd.kx')" :value="'1'"> </el-option>
              <el-option :label="$t('claimantKd.zc')" :value="'2'"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 索赔类型 -->
          <el-form-item :label="$t('claimantKd.spType')" prop="claimType">
            <el-select v-model="claimant.claimType" disabled filterable clearable>
              <el-option :label="$t('claimantKd.yssh')" :value="'1'"> </el-option>
              <el-option :label="$t('claimantKd.hc')" :value="'2'"> </el-option>
              <el-option :label="$t('claimantKd.zlwt')" :value="'3'"> </el-option>
              <el-option :label="$t('claimantKd.ztbf')" :value="'4'"> </el-option>
              <el-option :label="$t('claimantKd.qt')" :value="'5'"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 开箱日期 -->
          <el-form-item :label="$t('claimantKd.kxrq')" prop="openBoxDate">
            <el-date-picker
              disabled
              type="date"
              value-format="yyyy-MM-dd"
              v-model="claimant.openBoxDate"
              :placeholder="$t('placeholder.select')"
              style="width: 250px"
            ></el-date-picker>
          </el-form-item>
          <!-- 销售订单号 -->
          <el-form-item :label="$t('claimantKd.xsddh')" prop="claimStatementNum">
            <el-input
              disabled
              v-model="claimant.claimStatementNum"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 零部件专业 -->
          <el-form-item :label="$t('climant.partMajor')" v-show="claimant.lbjzyList">
            <el-select disabled v-model="claimant.lbjzyList" multiple placeholder=" " filterable clearable>
              <el-option :label="$t('climant.carBody')" :value="'1'"> </el-option>
              <el-option :label="$t('climant.chassis')" :value="'2'"> </el-option>
              <el-option :label="$t('climant.electricalAppliances')" :value="'3'">
              </el-option>
              <el-option
                :label="$t('climant.interiorAndExteriorDecoration')"
                :value="'4'"
              >
              </el-option>
              <el-option :label="$t('climant.newEnergy')" :value="'5'"> </el-option>
              <el-option :label="$t('climant.power')" :value="'6'"> </el-option>
            </el-select>
          </el-form-item>
          <!-- VIN -->
          <el-form-item :label="$t('seek.vin')" v-show="claimant.claimNode == 2">
            <el-input disabled v-model="claimant.vin"></el-input>
          </el-form-item>
          <!-- 国家 -->
          <el-form-item :label="$t('home.country')" prop="country">
            <el-input
              disabled
              v-model="person.country"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 客户账号 -->
          <el-form-item :label="$t('claimantKd.khzh')" prop="customerAccountNum">
            <el-input
              disabled
              v-model="claimant.customerAccount"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 客户索赔号 -->
          <el-form-item
            :label="$t('home.customerClaimNumber')"
          >
            <el-input
              disabled
              v-model="claimant.customerClaimNumber"
            ></el-input>
          </el-form-item>
        </div>
        <!-- 车辆故障信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img class="title-icon" src="@/assets/img/title-icon.svg" alt="dark" />
            {{ $t("climant.hitchInfo") }}
          </div>
        </div>
        <div class="form-container">
          <!-- 发生日期 -->
          <el-form-item :label="$t('seek.happenDate')">
            <el-date-picker
              disabled
              type="date"
              value-format="yyyy-MM-dd"
              v-model="claimant.happenDate"
            ></el-date-picker>
          </el-form-item>

          <!-- 故障现象 -->
          <div class="fanyi-box">
            <el-form-item :label="$t('climant.hitchAppearance')">
              <el-input
                disabled
                type="textarea"
                v-model="claimant.symptom"
                style="width: 670px"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 故障初步原因 -->
          <div class="fanyi-box">
            <el-form-item :label="$t('climant.hitchReson')">
              <el-input
                disabled
                type="textarea"
                v-model="claimant.preliminaryCauseOfFailure"
                style="width: 670px"
              ></el-input>
            </el-form-item>
          </div>

          <!-- 故障处理方案 -->
          <div class="fanyi-box">
            <el-form-item :label="$t('climant.hitchPlan')">
              <el-input
                disabled
                type="textarea"
                v-model="claimant.processingScenarios"
                style="width: 670px"
              ></el-input>
            </el-form-item>
          </div>
        </div>

        <!-- 故障件信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img class="title-icon" src="@/assets/img/title-icon.svg" alt="dark" />
            {{ $t("climant.gzjxxl") }}
          </div>
        </div>
        <div class="table-container" style="padding: 15px 18px 0 54px">
          <el-table
            ref="tableRef"
            :data="claimant.kdClaimFaultyPartsEntityList"
            stripe
            border
            highlight-current-row
          >
            <!-- 序号 -->
            <el-table-column
              type="index"
              :label="$t('cart.xh')"
              width="60"
              align="center"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 外包装箱号 -->
            <el-table-column
              prop="boxNumber"
              :label="$t('claimantKd.wbzxh')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 故障件件号 -->
            <el-table-column
              prop="faultPartNumber"
              :label="$t('climant.faultNo')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 故障件名称 -->
            <el-table-column
              prop="faultPartName"
              :label="$t('climant.faultName')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 故障件单价 -->
            <el-table-column
              prop="faultPartUnitPrice"
              :label="$t('climant.faultPrice')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency == 0 ? "￥" : "" }}
                  {{ claimant.currency == 1 ? "$" : "" }}
                  {{ scope.row.faultPartUnitPrice }}
                </div>
              </template>
            </el-table-column>
            <!-- 纸箱号 -->
            <el-table-column
              prop="cartonNumber"
              :label="$t('claimantKd.zxh')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 更换数量 -->
            <el-table-column
              prop="changeQuantity"
              :label="$t('climant.changeNum')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 维修方案 -->
            <el-table-column
              :label="$t('climant.wxfa')"
              prop="repairPlan"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <el-select v-model="scope.row.repairPlan" disabled filterable clearable>
                  <el-option :label="$t('climant.wx')" :value="0"> </el-option>
                  <el-option :label="$t('climant.gh')" :value="1"> </el-option>
                  <el-option :label="$t('claimantKd.bf')" :value="2"> </el-option>
                </el-select>
              </template>
            </el-table-column>
            <!-- 工时 -->
            <el-table-column
              prop="workingHours"
              :label="$t('climant.manHour')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 运费 -->
            <el-table-column
              prop="shippingFee"
              :label="$t('climant.transportationCost')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 关税 -->
            <el-table-column
              prop="tariff"
              :label="$t('climant.customs')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>

            <!-- 其他费用 -->
            <el-table-column
              prop="otherExpenses"
              :label="$t('climant.otherCost')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>

            <!-- 管理费费率 -->
            <el-table-column
              prop="managementFeeRate"
              :label="$t('climant.manageRate')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 工时费用 -->
            <el-table-column
              prop="laborCost"
              :label="$t('claimantKd.gsfy')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 材料费用 -->
            <el-table-column
              prop="materialCost"
              :label="$t('claimantKd.clfy')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 故障件总金额 -->
            <el-table-column
              prop="faultPartTotalPrice"
              :label="$t('climant.faultTotalPrice')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency == 0 ? "￥" : "" }}
                  {{ claimant.currency == 1 ? "$" : "" }}
                  {{ scope.row.faultPartTotalPrice }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 费用信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img class="title-icon" src="@/assets/img/title-icon.svg" alt="dark" />
            {{ $t("climant.costInfo") }}
          </div>
        </div>
        <div class="form-container">
          <!-- 工时 -->
          <el-form-item :label="$t('claimantKd.zgs') + '(h)'">
            <el-input-number
              disabled
              v-model="claimant.manHour"
              :controls="false"
              :min="0"
              :max="999"
              :precision="2"
            ></el-input-number>
          </el-form-item>
          <!-- 工时单价 -->
          <el-form-item :label="$t('climant.hourlyPrice')">
            <el-input-number
              disabled
              v-model="claimant.hourlyRate"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency == 0 ? "￥" : "" }}
              {{ claimant.currency == 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 工时总费用 -->
          <el-form-item :label="$t('claimantKd.gszfy')">
            <el-input-number
              disabled
              v-model="claimant.totalCostOfWork"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency == 0 ? "￥" : "" }}
              {{ claimant.currency == 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 材料总费用 -->
          <el-form-item :label="$t('claimantKd.clzfy')">
            <el-input-number
              disabled
              v-model="claimant.materialTotalCost"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency == 0 ? "￥" : "" }}
              {{ claimant.currency == 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 运费 -->
          <el-form-item :label="$t('claimantKd.zyf')">
            <el-input-number
              disabled
              v-model="claimant.freight"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency == 0 ? "￥" : "" }}
              {{ claimant.currency == 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 关税 -->
          <el-form-item :label="$t('claimantKd.zguanshui')" prop="tariff">
            <el-input-number
              disabled
              v-model="claimant.tariff"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency == 0 ? "￥" : "" }}
              {{ claimant.currency == 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 其他费用 -->
          <el-form-item :label="$t('claimantKd.qtzfy')">
            <el-input-number
              disabled
              v-model="claimant.otherTotalCost"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency == 0 ? "￥" : "" }}
              {{ claimant.currency == 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 结算币种 -->
          <el-form-item :label="$t('climant.currency')">
            <el-select disabled v-model="claimant.currency" filterable clearable placeholder="">
              <el-option label="CNY" :value="0"> </el-option>
              <el-option label="USD" :value="1"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 其他总费用说明 -->
          <el-form-item :label="$t('climant.otherCostCondition')" prop="otherInstruction">
            <el-input
              disabled
              v-model="claimant.otherExpenses"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 索赔总费用 -->
          <el-form-item :label="$t('climant.climantTotal')">
            <el-input-number
              disabled
              v-model="claimant.claimTotalCost"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency == 0 ? "￥" : "" }}
              {{ claimant.currency == 1 ? "$" : "" }}
            </div>
          </el-form-item>
        </div>
        <!-- 附件信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img class="title-icon" src="@/assets/img/title-icon.svg" alt="dark" />
            {{ $t("home.attachmentInfo") }}
          </div>
        </div>
        <div class="form-container">
          <el-form-item :label="$t('home.attachmentInfo')">
            <div
              class="flex"
              v-for="(item, i) in claimant.kdClaimFaultyPartsEntityList"
              :key="i"
            >
              <span style="font-weight: bold">{{ $t("zlfk.fj") }}{{ i + 1 }}:</span>
              <div class="file">
                <file-upload-list
                  ref="fileUploadList"
                  :fileList="item.fileList"
                ></file-upload-list>
                <!-- <div
                  class="file-list"
                  style="cursor: pointer"
                  v-for="(data, idx) in item.fileList"
                  :key="idx"
                >
                  <div class="left">
                    <i class="el-icon-document"></i><span>{{ data.fileName }}</span>
                  </div>
                  <div class="down-icon" v-if="data.downStatus">
                    {{ $t("operate.alreadyDown") }}
                  </div>
                  <div class="right" @click="downLoad(data.filePath, idx)">
                    {{ $t("home.down") }}
                  </div>
                  <div
                    class="right"
                    style="margin-left: 10px"
                    v-if="showViewBtn(data.fileType)"
                    @click="viewFile(data)"
                  >
                    {{ $t("operate.preview") }}
                  </div>
                </div> -->
              </div>
            </div>
          </el-form-item>
        </div>
        <!-- 审核信息 -->
        <div v-if="claimStatementAudit?.auditType" class="hearder-title">
          <div class="flex_between">
            <img class="title-icon" src="@/assets/img/title-icon.svg" alt="dark" />
            <span v-if="claimStatementAudit.auditType == 6">
              {{ $t("climant.jsxx") }}
            </span>
            <span v-else-if="claimStatementAudit.auditType == 3">
              {{ $t("climant.zrqrxx") }}
            </span>
            <span v-else> {{ $t("climant.shxx") }}</span>
          </div>
        </div>
        <div v-if="claimStatementAudit.auditType" class="form-container">
          <!-- 流程环节 -->
          <el-form-item :label="$t('climant.lchj')">
            <el-input disabled v-model="claimStatementAudit.auditType" />
          </el-form-item>
          <!-- 流程结果 -->
          <el-form-item
            v-if="
              !(
                claimStatementAudit.auditType == $t('seek.submit') ||
                claimStatementAudit.auditType == $t('message.js') ||
                claimStatementAudit.auditType == $t('message.cancel') ||
                claimStatementAudit.auditType == $t('message.revocate')
              )
            "
            :label="$t('climant.lcjg')"
          >
            <el-input disabled v-model="claimStatementAudit.status"></el-input>
          </el-form-item>
          <!-- 驳回原因 -->
          <el-form-item
            v-if="claimStatementAudit['remark' + $i18n.locale]"
            :label="$t('zlfk.bhyy')"
          >
            <el-input
              disabled
              v-model="claimStatementAudit['remark' + $i18n.locale]"
            ></el-input>
          </el-form-item>
          <!-- 操作人 -->
          <el-form-item :label="$t('climant.czry')">
            <el-input disabled v-model="claimStatementAudit.staffName"></el-input>
          </el-form-item>
          <!-- 操作时间 -->
          <el-form-item :label="$t('climant.czsj')">
            <el-input disabled v-model="claimStatementAudit.createTime"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div v-else class="record_info">
      <!-- 查看记录 -->
      <div class="hearder-title">
        <div class="flex_between">
          <img class="title-icon" src="@/assets/img/title-icon.svg" alt="dark" />
          {{ $t("climant.lsjl") }}
          <el-button
            style="margin-left: 20px"
            type="primary"
            class="primary-btn"
            size="mini"
            @click="handleViewRecord('detail')"
            >{{ $t("zlfk.backto") }}</el-button
          >
        </div>
      </div>
      <div class="form-container">
        <audit-record :recordList="recordList" />
      </div>
    </div>
    <div class="flex_default_center" v-if="$route.query.messageId">
      <el-button
        v-if="
          claimant.status == 0 ||
          claimant.status == 2 ||
          claimant.status == 4 ||
          claimant.status == 9
        "
        size="small"
        class="primary-btn"
        type="primary"
        @click="handleReEdit"
      >
        {{ $t("climant.reEdit") }}
      </el-button>
      <el-button size="small" class="primary-btn" type="primary" @click="back">
        {{ $t("zlfk.backto") }}
      </el-button>
    </div>
    <view-img-video ref="viewRef" :list="previewList" />
  </div>
</template>
<script>
import { getStorage, getSession, setStorageNew } from "@/util/localStor";
import { readMsg } from "@/api/part";
import TranslateBtn from "@/components/translateBtn";
import AuditRecord from "../claimant/auditRecord.vue";
import { auditHistoryList, claimantList, getUserInfo } from "@/api/kdsuopei";
import { messageReading } from "@/api/seek";
import { getDictItem, getDictValue } from "@/util/dict";
import ViewImgVideo from "@/components/viewImgVideo.vue";

export default {
  components: { TranslateBtn, AuditRecord, ViewImgVideo },
  data() {
    return {
      previewList: [],
      partMajorList: [
        {
          name: "车身",
          id: 1,
        },
        {
          name: "底盘",
          id: 2,
        },
        {
          name: "电器",
          id: 3,
        },
        {
          name: "内外饰",
          id: 4,
        },
        {
          name: "新能源",
          id: 5,
        },
        {
          name: "动力",
          id: 6,
        },
      ], // 零部件专业
      fileList: [],
      claimant: {},
      tableData: [
        {
          id: 1,
          num: "A006-Q123-98",
          name: "车窗",
          price: "86",
          fl: "0.5",
          sl: "1",
          total: "865",
          isErr: "是",
        },
      ],
      pageIndex: "detail", // 详情 | 记录
      recordList: [],
      claimStatementAudit: {
        auditType: "",
      },
      exchangeRate: "",
      person: {},
    };
  },
  watch: {
    // 语言切换时，清空表单验证
    "$i18n.locale": function () {
      this.getAuditLocale();
    },
  },
  async mounted() {
    this.claimant = getStorage("claimantData");
    this.getPersonData();
    const fileList = this.claimant.kdClaimFaultyPartsEntityList?.reduce((acc, item) => {
      if (item.fileList.length > 0) {
        acc.push(...item.fileList);
      }
      return acc;
    }, []); // 初始值为空数组

    this.previewList = fileList?.filter((item) => {
      return "image,video".indexOf(item.fileType.slice(0, 5)) !== -1;
    });
    this.getExchangeRate();
    if (this.$route.query?.messageId && this.$route.query?.claimantId) {
      // 将未读消息改为已读
      if (!(this.$route.query?.messageStatus == 1)) {
        messageReading({
          data: { messageList: [this.$route.query?.messageId] },
        });
      }
      const res = await claimantList({
        data: {
          claimStatementNum: this.$route.query?.claimantId,
        },
        page: {
          pageNum: 1,
          pageSize: 1,
        },
      });
      if (res.status == 0) {
        this.claimant = res.data.records[0] || {};
      } else {
        this.$DonMessage.error(res.message);
      }
    }

    if (this.$route.query && this.$route.query.unread > 0) {
      this.readDetail();
    }
    const res = await auditHistoryList({
      data: { claimStatementId: this.claimant.claimStatementId },
    });
    this.recordList = res.data;
    this.$nextTick(() => {
      if (this.recordList.length > 0) {
        this.getAuditLocale();
      }
    });
  },
  methods: {
    // 获取客户信息
    async getPersonData() {
      const res = await getUserInfo();
      if (res.status == 0) {
        this.person = res.data;

        if (this.$i18n.locale !== "zh") {
          let nationList = Object.values(getSession("nationList"));
          nationList.map((item) => {
            if (item.id == res.data.customerCountry) this.person.country = item.enName;
          });
        }
      }
    },
    // 审核记录多语言处理
    getAuditLocale() {
      // this.claimStatementAudit = JSON.parse(
      //   JSON.stringify(this.claimant.claimStatementAudit || {})
      // );
      let arr = JSON.parse(JSON.stringify(this.recordList));
      this.claimStatementAudit = arr.slice(-1)[0];
      // if (this.claimant?.claimStatementAudit?.auditType == 0) {
      if (this.claimStatementAudit?.auditType == 0) {
        this.claimStatementAudit.auditType = this.$t("message.sh");
      }
      if (this.claimStatementAudit?.auditType == 1) {
        this.claimStatementAudit.auditType = this.$t("message.sh");
      }
      if (this.claimStatementAudit?.auditType == 3) {
        this.claimStatementAudit.auditType = this.$t("message.zrqr");
      }
      if (this.claimStatementAudit?.auditType == 5) {
        this.claimStatementAudit.auditType = this.$t("seek.submit");
      }
      if (this.claimStatementAudit?.auditType == 6) {
        this.claimStatementAudit.auditType = this.$t("message.js");
      }
      if (this.claimStatementAudit?.auditType == 7) {
        this.claimStatementAudit.auditType = this.$t("message.cancel");
      }
      if (this.claimStatementAudit?.auditType == 8) {
        this.claimStatementAudit.auditType = this.$t("operate.revocate");
      }
      if (this.claimStatementAudit?.auditType == 9) {
        this.claimStatementAudit.auditType = this.$t("climant.secondFill");
      }
      if (this.claimStatementAudit?.auditType == 11) {
        this.claimStatementAudit.auditType = this.$t("operate.revocate");
      }
      if (this.claimStatementAudit?.status == 1) {
        this.claimStatementAudit.status = this.$t("home.passed");
      }
      if (this.claimStatementAudit?.status == 2) {
        this.claimStatementAudit.status = this.$t("zlfk.bty");
      }
      if (this.claimStatementAudit?.status == 3) {
        this.claimStatementAudit.status = this.$t("message.bh");
      }
      if (this.claimStatementAudit?.status == 4) {
        this.claimStatementAudit.status = this.$t("message.jp");
      }
      if (this.claimStatementAudit?.status == 5) {
        this.claimStatementAudit.status = this.$t("zlfk.clz");
      }
      if (this.claimStatementAudit?.status == 6) {
        this.claimStatementAudit.status = this.$t("message.yspass");
      }
      if (this.claimStatementAudit?.status == 7) {
        this.claimStatementAudit.status = this.$t("climant.ych");
      }
      if (this.claimStatementAudit?.status == 8) {
        this.claimStatementAudit.status = this.$t("home.canceled");
      }
    },
    // 获取汇率
    async getExchangeRate() {
      const exchangeRateDict = await getDictItem("exchangeRate");
      const exchangeRateItem = getDictValue(exchangeRateDict, "USD/CNY");
      this.exchangeRate = exchangeRateItem?.codeText || this.exchangeRate;
    },
    back() {
      this.$router.go(-1);
    },
    // 获取翻译值
    getTranslateVal(field, value) {
      this.$set(this.claimant, field, value);
    },
    // 详情 | 记录
    handleViewRecord(index) {
      this.pageIndex = index;
    },
    async readDetail() {
      const query = {
        data: {
          dataId: this.claimant.claimStatementId,
          customerId: getSession("claimant").customerId,
          notificationType: 2,
        },
      };
      const res = await readMsg(query);
      this.$store.state.refresh = new Date().getTime();
    },
    // 下载
    downLoad(url, index) {
      this.$set(this.claimant.fileList[index], "downStatus", true);
      window.open(url);
    },
    showViewBtn(type) {
      const fileExtension = type.slice(0, 5);
      return "image,video".indexOf(fileExtension) !== -1;
    },
    // 预览
    viewFile(data) {
      this.$refs.viewRef.init(data);
    },
    // 重新编辑
    handleReEdit() {
      setStorageNew("claimantData", this.claimant);
      this.$router.push("/newClaimant");
    },
  },
};
</script>
<style lang="scss" scoped>
.seek_detail_page {
  padding: 0 !important;
  // padding-bottom: 20px;
  // ::v-deep .el-input {
  //   width: 300px;
  // }
  .top-container {
    padding: 10px 32px 10px 14px;
    border-bottom: 5px solid #efefef;
    .split {
      margin: 0 10px 0 7px;
      border: 1px solid #dde0e8;
      height: 18px;
    }
  }
  .status-container {
    display: flex;
    align-items: baseline;
    padding: 13px 44px;
    border-bottom: 1px solid #dcdee0;
    .status {
      margin: 0 85px;
    }
    .btn {
      padding: 0;
      font-size: 16px;
    }
  }
  .hearder-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title-icon {
      margin-right: 10px;
    }
    .flex_between{
      display: flex !important;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .second-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #bd3124;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .form-container {
    margin-top: 34px;
    padding: 0 60px;
  }
  .number-input {
    ::v-deep .el-input__inner {
      text-align: left;
    }
  }
  .number-input-prepend {
    // background-color: #f5f7fa;
    // color: #909399;
    // border-right: 1px solid #dcdfe6;
    // vertical-align: middle;
    // border-radius: 4px 0 0 4px;
    // display: inline-block;
    // height: 38px;
    // line-height: 38px;
    // width: 40px;
    // text-align: center;
    // position: absolute;
    // left: 1px;
    // top: 60%;
    // transform: translateY(-60%);
  }
  .prepend-padding {
    ::v-deep .el-input__inner {
      // padding-left: 55px;
    }
  }
  .fanyi-box {
    ::v-deep .el-textarea__inner {
      height: 100px;
    }
    .textAreaTipBtn {
      cursor: pointer;
      width: fit-content;
      color: #bd3124;
    }
  }
}
.file {
  .down-icon {
    margin-left: 10px;
    color: #1890ff;
  }
  // width: 100%;
  .file-list {
    // background: #eee;
    margin: 0 10px;
    padding: 0 5px;
    // width: 200px;
    box-sizing: border-box;
    border-radius: 3px;
    display: flex;
    // justify-content: center;
    align-items: center;
    cursor: pointer;
    display: flex;
    i {
      font-size: 20px;
    }
    span {
      display: inline-block;
      font-size: 12px;
      margin-left: 5px;
    }
    .right {
      font-size: 12px;
      padding: 0 5px;
      border: 1px solid #4095e5;
      text-align: center;
      margin-left: 30px;
      border-radius: 6px;
      height: 26px;
      line-height: 26px;
      box-sizing: border-box;
      opacity: 0;
    }
  }
  .file-list:hover {
    background: rgb(243, 246, 249);
    color: #4095e5;
    .right {
      opacity: 1;
    }
  }
}
.red_label {
  color: red;
  font-weight: bold;
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 400px;
}
</style>
